// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zc3Y","name":"styles_name__3zE0N","phone":"styles_phone__3I-Hn"};